import { PrivateLibraryService } from 'src/app/core/services/private-library.service';
import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { LITERALS } from 'src/app/core/constants/literals.constant';
import { SuccessMessageComponent } from '../../all-modals/success-message/success-message.component';
import { ErrorMessageComponent } from '../../all-modals/error-message/error-message.component';
import { WipodService } from 'src/app/core/services/wipod.service';

@Component({
  selector: 'app-confirm-delete-modal',
  templateUrl: './remove-adp-content.component.html',
  styleUrls: ['./remove-adp-content.component.scss']
})
export class RemoveADPContentComponent implements OnInit {

  @Input() public contentId;
  @Input() public message;
  @Input() public title;
  @Input() public library_type;
  @Input() public library_typeStatus;  
  @Input() public contentId1;
  @Input() public business_name;

  @Input() public library_owner_id;

  @Input() public successActionButtonName;
  @Input() public is_part_of_package;
  @Input() public is_part_of_playlist;
  @Input() public is_addition_lib;
  @Input() public fromUser;


  constructor(
    private activeModal: NgbActiveModal,
    private spinner: NgxSpinnerService,
    private modalService: NgbModal,
    private privateLibraryService: PrivateLibraryService,
    private wipodService: WipodService
  ) { }

  ngOnInit() {
  }
  open(){
    console.log("adsf");
    
  }
  
 
  removeContent() {
 var obj = {
      "content_id": this.contentId1,
      "user_outlet_id":this.library_owner_id
    }
    this.spinner.show();
    this.privateLibraryService.updateContentADP(obj).subscribe((response: any) => {
      if (response.success) {
        this.spinner.hide();
        this.activeModal.close(true);
        const modelRef = this.modalService.open(SuccessMessageComponent, { centered: true });
        modelRef.componentInstance.message = response.message;
      }
      else if (response.errors == "Content not found") {
        this.spinner.hide();
        const modalRef = this.modalService.open(ErrorMessageComponent, { centered: true });
        modalRef.componentInstance.message = LITERALS.AUTH.ERROR_MESSAGES.CONTENT_NOT_FOUND;
        // this.toastr.warning(LITERALS.AUTH.ERROR_MESSAGES.CONTENT_NOT_FOUND);
        this.activeModal.close(true);
      } else {
        this.spinner.hide();
        const modalRef = this.modalService.open(ErrorMessageComponent, { centered: true });
        modalRef.componentInstance.message = response.errors;
        this.activeModal.close();
      }
    }, (error: any) => {
      this.spinner.hide();
      // this.toastr.warning(LITERALS.AUTH.ERROR_MESSAGES.SOMETHING_WENT_WRONG);
    })
  }
  removeWipodContent() {
    this.spinner.show();
    let deleteSubscriber: any;

    if (this.fromUser == 'owner') {
      deleteSubscriber = this.wipodService.deleteWipodContent(this.contentId);
    }
    else {
      let obj = {
        "content_id": this.contentId
      }
      deleteSubscriber = this.wipodService.deleteContentRights(obj);
    }

    deleteSubscriber.subscribe((response: any) => {
      if (response.success) {
        this.spinner.hide();
        this.activeModal.close(true);
        const modelRef = this.modalService.open(SuccessMessageComponent, { centered: true });
        modelRef.componentInstance.message = LITERALS.AUTH.SUCCESS_MESSAGES.CONTENT_DELETED_SUCCESSFULLY;
      }
      else {
        this.spinner.hide();
        const modalRef = this.modalService.open(ErrorMessageComponent, { centered: true });
        modalRef.componentInstance.message = response.errors;
        this.activeModal.close();
      }
    })
  }

  removeSuccess() {
    this.activeModal.close('success');
  }
  closeDialog() {
    this.activeModal.dismiss();
  }
}
